import React from "react";
import './VerticalFarming.css';
import SearchBar from "../Search/SearchBar";

const VerticalFarming = () => {
      return (
        <>
          <section className="verticalFarming">
            <div className="verticalFarmingHero">
            <div className="searchBarWrapper">
              <SearchBar />
            </div>
              <h4 className="heroTitle">FARMING TECHNIQUES</h4>
            </div>
            <div className="verticalFarmingContent">
              <h3>Vertical Farming</h3>
              <h4>What is Vertical Farming?</h4>
              <p className="paragraphWrapper">
                <span className="paragraphSubHead">Vertical farming</span> is an innovative technique that involves
                growing crops in vertically stacked
                layers, often in controlled environments like indoor facilities,
                warehouses, or high-rise
                buildings. Unlike conventional horizontal farming that heavily
                relies on vast tracts of land,
                vertical farming makes efficient use of space by utilizing
                height.
              </p>
              <div className="verticalFarmImage">
                <img src="/FrameHome.png" alt="farming" />
              </div>
              
              <h4>Key features of Vertical Farming</h4>
              <p className="paragraphWrapper">
                Vertical farming is a modern agricultural technique that has
                several key features.
                Some of them are:
              </p>
              <ol className="ordLists">
                <li>
                <span className="paragraphSubHead">Vertical Growing Structures:</span> crops are oultivated in
                  vertically stacked layers using

                  shelves, racks, or towers. This method allows for high-density
                  planting and optimal use of

                  available space.
                </li>
                <li>
                <span className="paragraphSubHead">Controlled Environment:</span> vertical farming facilities are
                  equipped with climate control

                  systems that carefully monitor and optimize temperature,
                  humidity, light, and nutrient

                  levels for plant growth. This control minimizes the impact of
                  external factors such as

                  weather and pests, resulting in consistent and predictable
                  crop yields.
                </li>
                <li>
                <span className="paragraphSubHead">Hydroponic or Aeroponic systems:</span> many vertical farms use
                  hydroponic or aeroponic

                  systems for soilless cultivation. In hydroponics, plants are
                  grown in nutrient-rich water

                  solutions, while in aeroponics, plants are misted with
                  nutrient-rich air. These systems

                  provide plants with essential nutrients, while minimizing
                  water usage and eliminating the

                  need for soil.
                </li>
                <li>
                <span className="paragraphSubHead">Artificial Lighting:</span> as natural sunlight may be limited in
                  indoor environments, artificial

                  lighting systems such as LED grow lights are used to provide
                  the necessary light

                  spectrum for photosynthesis. These lighting systems can be
                  tailored to the specific needs

                  of different crops and growth stages.
                </li>
                <li>
                <span className="paragraphSubHead">Urban Agriculture:</span> vertical farming, is highly suitable for
                  urban areas with limited land

                  availability and high demand for locally grown produce.
                  Vertical farms help to bring food

                  production closer to consumers, reducing transportation costs
                  and carbon emissions

                  associated with traditional agriculture.
                </li>
              </ol>
              <h4>
                Types of Plants and Methods of Growing them Using Vertical
                Farming
              </h4>
              <ol className="ordLists">
                <li>Vegetables</li>
                <li>Grains</li>
                <li>Tuber</li>
              </ol>

              <div className="vegetable">
                <h4>1. VEGETABLES</h4>
                <p className="paragraphWrapper">
                  Vertical farming offers unique opportunities for growing
                  vegetables efficiently in

                  controlled environments. Here's a breakdown of pre-planting,
                  planting, and post-

                  planting methods specific to vertical farming:
                </p>
                <ol className="ordLists">
                  <li>
                    <span className="ordListsSub">Pre-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Crop Selection:</span> Choose vegetable crops that are
                        well-suited for vertical farming, considering factors
                        such as growth habit, light requirements, and space
                        efficiency. Leafy greens like lettuce, herbs like basil,
                        and compact varieties of tomatoes and cucumbers are
                        popular choices.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Facility Design:</span> Design the vertical farming facility
                        to maximize space utilization and optimize environmental
                        conditions. This includes selecting appropriate shelving
                        or tower systems, installing climate control systems for
                        temperature and humidity regulation, and implementing
                        efficient lighting solutions.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Substrate Preparation:</span> Depending on the cultivation
                        method (e.g., hydroponics, aeroponics), prepare the
                        growing substrate or medium. For hydroponic systems,
                        this may involve setting up nutrient reservoirs and
                        circulating systems. For aeroponic systems, ensure
                        proper misting equipment and nutrient delivery systems
                        are in place.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span  className="ordListsSub">Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Seedling Production:</span> Start with high-quality seeds or
                        seedlings suited to vertical farming conditions. Use
                        seedling trays or propagation systems to germinate seeds
                        and grow healthy seedlings before transplanting them
                        into the vertical farming system.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Transplanting:</span> Once seedlings are ready, transplant
                        them into the vertical growing system according to the
                        specific layout and spacing requirements. Ensure proper
                        spacing between plants to prevent overcrowding and allow
                        for adequate air circulation and light penetration.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Vertical Arrangement:</span> Arrange plants vertically on
                        shelves, racks, or towers, taking advantage of available
                        space. Consider factors such as plant height, growth
                        rate, and light requirements when positioning plants
                        within the vertical structure.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Post-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Nutrient Management:</span> Monitor and maintain nutrient
                        levels in hydroponic or aeroponic systems to ensure
                        optimal plant nutrition. Regularly test nutrient
                        solutions and adjust as needed to meet the requirements
                        of different vegetable crops at various growth stages.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Watering and Irrigation:</span> Implement efficient watering
                        and irrigation systems to deliver water and nutrients to
                        plants while minimizing waste. Automated irrigation
                        systems with timers or sensors can help ensure
                        consistent moisture levels and prevent overwatering or
                        underwatering.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Pruning and Training:</span> Regularly prune and train vegetable plants to promote healthy growth and maximize productivity. Remove damaged or diseased foliage, and use trellising or support structures to guide plant growth vertically and prevent sprawling.
                      </li>
                    </ul>
                  </li>
                </ol>

                <div className="verticalFarmImage1">
                  <img src="/FrameHome.png" alt="farming" />
                  <img src="/AboutUs3.png" alt="farming" />
                </div>
                
                <p className="moreExplanations">
                  By following these pre-planting, planting, and post-planting
                  methods tailored to vertical farming, you can optimize
                  vegetable production in controlled environments and maximize
                  the benefits of this innovative agricultural approach.
                </p>
              </div>

              <div className="grains">
                <h4>2. GRAINS</h4>
                <p className="paragraphWrapper">
                  Grains are typically not the first choice for vertical farming
                  due to their large size and space requirements. However, some
                  smaller grains like quinoa or certain varieties of wheat might
                  be suitable for experimental or specialized vertical farming
                  setups. Here's a general overview of pre-planting, planting,
                  and post-planting methods for grains in vertical farming:
                </p>
                <ol className="ordLists">
                  <li>
                  <span className="ordListsSub">Pre-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Crop Selection:</span> Choose grain crops that are
                        well-suited for vertical farming conditions. Consider
                        smaller varieties or pseudo-grains like quinoa that can
                        adapt to the limited space available in vertical farming
                        setups.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Watering and Irrigation:</span> Plant seeds in appropriate growing containers
                        or trays filled with growing medium. Ensure proper
                        spacing between seeds to prevent overcrowding and allow
                        for adequate root development.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Seed Selection:</span> Use high-quality seeds suited to
                        vertical farming conditions. Consider factors such as
                        germination rate, disease resistance, and suitability
                        for indoor cultivation.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Seed Preparation:</span> Depending on the grain crop,
                        prepare seeds for planting by cleaning, sorting, and
                        treating them as necessary. Some grains may require
                        scarification or other pre-treatment methods to promote
                        germination.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Sowing:</span> Plant grain seeds in the vertical farming
                        system according to spacing and depth requirements. Use
                        appropriate planting techniques to ensure uniform
                        germination and seedling establishment.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Germination:</span> Provide optimal conditions for seed
                        germination, including consistent moisture, temperature,
                        and light levels. Monitor germination progress closely
                        and adjust environmental conditions as needed to support
                        seedling development.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Post-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Nutrient Management:</span> If using a hydroponic system,
                        monitor and adjust nutrient levels to support grain
                        growth throughout the growing cycle. Ensure that grain
                        crops receive adequate macronutrients and micronutrients
                        to support healthy development.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Watering and Irrigation:</span> Implement efficient watering
                        and irrigation systems to provide moisture to grain
                        crops while minimizing water waste. Monitor soil
                        moisture levels or nutrient solution levels regularly
                        and adjust irrigation accordingly.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Support and Training:</span> Depending on the growth habit
                        of the grain crop, provide support structures or
                        trellising as needed to prevent lodging and promote
                        upright growth. Train grain plants to grow vertically
                        within the available space to maximize yield potential.
                      </li>
                    </ul>
                  </li>
                </ol>

                <div className="verticalFarmImage1">
                  <img src="/Grain vertical.png" alt="farming" />
                  <img src="/Grain 2.png" alt="farming" />
                </div>
                
                <p className="moreExplanations">
                  While growing grains in vertical farming setups presents
                  certain challenges, with careful planning and adaptation of
                  traditional farming methods, it may be possible to experiment
                  with smaller grain varieties in controlled indoor
                  environments.
                </p>
              </div>
              <div className="tuber">
                <h4>3. TUBER</h4>
                <p className="paragraphWrapper">
                  Growing tubers, such as potatoes or sweet potatoes, in
                  vertical farming setups requires special consideration due to
                  their underground growth habit and space requirements. Here's
                  a general overview of pre-planting, planting, and
                  post-planting methods for tubers in vertical farming:
                </p>

                <ol className="ordLists">
                  <li>
                  <span className="ordListsSub">Pre-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Crop Selection:</span> Choose tuber crops that are
                        well-suited for vertical farming conditions. Look for
                        compact or dwarf varieties that produce smaller tubers
                        and can adapt to the limited space available in vertical
                        farming setups.
                      </li>
                      <li>
                        <span className="paragraphSubHead">b. Facility Design:</span> Design the vertical farming facility
                        to accommodate the specific needs of tuber crops. Ensure
                        sufficient depth and space in growing containers or
                        towers to accommodate tuber development underground.
                        Install appropriate lighting, irrigation, and climate
                        control systems to support tuber growth.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Seed Selection:</span> Use high-quality seed tubers suited
                        to vertical farming conditions. Select disease-free,
                        firm tubers with multiple eyes or sprouts for optimal
                        germination and growth.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Preparing Seed Tubers:</span> Prior to planting, prepare
                        seed tubers by cutting them into pieces containing at
                        least one eye or sprout. Allow cut surfaces to dry and
                        callus before planting to reduce the risk of rotting.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Planting:</span> Plant prepared seed tubers in growing
                        containers or towers filled with growing medium. Place
                        seed tubers with sprouts facing upwards and bury them at
                        a suitable depth to allow for tuber development. Ensure
                        proper spacing between tubers to prevent overcrowding
                        and allow for adequate root development.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Covering:</span> Cover planted seed tubers with a layer of
                        growing medium to protect them from light exposure and
                        promote root growth. Maintain appropriate moisture
                        levels in the growing medium to support tuber
                        development.
                      </li>
                    </ul>
                  </li>
                  <li>
                  <span  className="ordListsSub">Post-Planting Methods:</span>
                    <ul className="unordLists">
                      <li>
                      <span className="paragraphSubHead">a. Nutrient Management:</span> Monitor and adjust nutrient
                        levels to support tuber growth throughout the growing
                        cycle. Ensure that tuber crops receive adequate
                        nutrients, particularly potassium, phosphorus, and
                        nitrogen, to support tuber development and yield.
                      </li>
                      <li>
                      <span className="paragraphSubHead">b. Watering and Irrigation:</span> Implement efficient watering
                        and irrigation systems to provide moisture to tuber
                        crops while minimizing water waste. Monitor soil
                        moisture levels or nutrient solution levels regularly
                        and adjust irrigation accordingly.
                      </li>
                      <li>
                      <span className="paragraphSubHead">c. Hilling:</span> As tuber plants grow, periodically add
                        additional growing medium or mulch around the base of
                        the plants to cover emerging tubers and promote further
                        growth. Hilling helps prevent tubers from being exposed
                        to light, which can cause greening and bitterness.
                      </li>
                      <li>
                      <span className="paragraphSubHead">d. Harvesting:</span> Harvest tubers when they reach maturity,
                        typically indicated by the senescence or yellowing of
                        the aboveground foliage. Carefully dig up tubers from
                        the growing containers or towers, taking care not to
                        damage them during harvest.
                      </li>
                    </ul>
                  </li>
                </ol>

                <div className="verticalFarmImage1">
                  <img src="/tuber verticall 1.png" alt="farming" />
                  <img src="/Vertical Tuber 1.png" alt="farming" />
                </div>
                
                <p className="moreExplanations">
                  While growing tubers in vertical farming setups presents
                  certain challenges, with careful planning and adaptation of
                  traditional farming methods, it is possible to experiment with
                  tuber production in controlled indoor environments.
                </p>
              </div>
            </div>
          </section>
        </>
      );
}

export default VerticalFarming;